import { setInventoryViewerModalHidden } from '@src/redux/slices/inventoryViewerModalSlice'
import { store } from '@atredux/store'

export const inventoryViewerModalListener = async () => {

    store.dispatch(setInventoryViewerModalHidden())
    return Promise.resolve({})
}
